import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const CORPORATION_ENDPOINT = {
  USER_ASSOCIATED_CORP_LIST: {
    method: EMethod.GET,
    url: "/corp/associated",
    version: API_VERSION.V0,
  },
  GET_DETAIL_BUSINESS_ESTABLISHMENT: {
    method: EMethod.GET,
    url: "/corp/business-establishment",
    version: API_VERSION.V0,
  },
  GET_DETAIL_JOB_LISTING: {
    method: EMethod.GET,
    url: "/corp/job-listing",
    version: API_VERSION.V0,
  },
  GET_DETAIL_ORGANIZATION: {
    method: EMethod.GET,
    url: "/corp/organization",
    version: API_VERSION.V0,
  },
  GET_ACTIVE_VACANCIES: {
    method: EMethod.POST,
    url: "/corp/active-vacancies/list",
    version: API_VERSION.V0,
  },
  SEARCH_JOB_LISTING: {
    method: EMethod.GET,
    url: "/corp/job-listing/search",
    version: API_VERSION.V0,
  },
};
